import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import {  groupsByProjectId } from "../graphql/queries";
import {  GroupsByProjectIdQuery } from "../API";



export async function fetchLLMGroups(
  projectId: string
): Promise<GraphQLResult<GroupsByProjectIdQuery>> {
  
  return API.graphql(
    graphqlOperation( groupsByProjectId, {
      projectId: projectId,
    })
  ) as Promise<GraphQLResult<GroupsByProjectIdQuery>>;
}